import { createSignal } from 'solid-js';
import styles from './PlayerHeadAvatar.module.css';

interface PlayerHeadAvatarProps {
    name: string;
    size?: number;
    online?: boolean;
    showStatus?: boolean;
}

export default function PlayerHeadAvatar(props: PlayerHeadAvatarProps) {
    const [failed, setFailed] = createSignal(false);
    const size = () => props.size ?? 32;

    return (
        <span class={styles.wrap} style={{ width: `${size()}px`, height: `${size()}px` }}>
            {!failed() ? (
                <img
                    class={styles.head}
                    src={`https://mc-heads.net/avatar/${encodeURIComponent(props.name)}/${Math.min(size() * 2, 128)}`}
                    alt=""
                    width={size()}
                    height={size()}
                    loading="lazy"
                    onError={() => setFailed(true)}
                />
            ) : (
                <i class={`fa-solid fa-user ${styles.fallback}`} style={{ 'font-size': `${size() * 0.5}px` }} />
            )}
            {props.showStatus && (
                <span
                    class={styles.statusRing}
                    classList={{ [styles.online]: !!props.online, [styles.offline]: !props.online }}
                />
            )}
        </span>
    );
}
